var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"toggle-btn",class:(_vm.type + " " + (_vm.isOpen ? 'open' : '')),on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('span',{staticClass:"icon-left"}),_c('span',{staticClass:"icon-right"})])}
var staticRenderFns = []

export { render, staticRenderFns }